<span *ngIf="isSuccessfull" class="success">Success</span><span *ngIf="!isSuccessfull" class="failed">Failed</span>
